import { Filter } from './filters-original.interface';

export interface PropertyLocation {
  apt?: string;
  street?: string;
  city?: string;
  state?: string;
  country?: string;
  country_code?: string;
  postcode?: string;
  latitude?: number;
  longitude?: number;
}

export interface SimpleProperty {
  id: number;
  name: string;
  picture: string;
  location: PropertyLocation;
  currency: string;
  muted?: boolean;
  listed?: boolean;
}

export interface CleaningFeeValue {
  type: 'fixed' | 'percent';
  value: number;
}

export interface CleaningFee {
  [key: string]: CleaningFeeValue | undefined;
}

export interface Property {
  id: number;
  name: string;
  picture: string;
  location: PropertyLocation;
  currency: string;
  calendar_restricted?: boolean;
  can_manage_availability?: boolean;
  muted?: boolean;
  listed?: boolean;
  has_smartlocks?: boolean;
  cleaning_fee?: CleaningFee;
  _wasRedirected?: boolean;
  _originalRequestedId?: string;
  owner?: {
    id: number;
    email: string;
    name: string;
    phone: string | null;
  };
}

export enum PropertyIncludes {
  Owner = 'owner',
  HasSmartlocks = 'has_smartlocks',
  PayoutMethods = 'payout_methods',
}

export interface GetPropertiesRequest {
  filterCriteria?: Filter[];
  offset?: number;
  search?: string;
  limit?: number;
  paginate?: boolean;
  transformer?: 'simple';
  idList?: Array<string | number>;
  includes?: PropertyIncludes[];
}

export interface GetPropertiesResponse {
  data: SimpleProperty[];
  meta?: {
    pagination?: {
      total: number;
      count: number;
      per_page: number;
      current_page: number;
      total_pages: number;
      links: {
        next?: string;
        previous?: string;
      };
    };
  };
}
